import { render, staticRenderFns } from "./BurgerToggle.vue?vue&type=template&id=318701f4"
import script from "./BurgerToggle.vue?vue&type=script&lang=js"
export * from "./BurgerToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports